import { targetHandoffMs } from "./targetCharge";

// Het feestje: zelf aan te zetten met Shift+8, of typ "feest" op de tv.
// Alles telt in slagen zodat beeld en muziek samen blijven lopen. Ander nummer
// in public/sounds/feest.mp3? Pas dan partyBeatMs en partyMs aan, en
// --fx-party-beat en --fx-party-ms in animations.css.

// 120 slagen per minuut.
export const partyBeatMs = 500;

// De lengte van feest.mp3 (Celebration, 16,9s); het dansen loopt even lang.
export const partyMs = 16900;

// Banen en balk stoppen eerder, zodat het beeld tot rust komt tijdens de uitfade.
export const partyBlocksMs = 28 * partyBeatMs; // 14,0s
export const partyHypeAt = 2 * partyBeatMs; // 1,0s
export const partyLineMs = 5 * partyBeatMs; // 2,5s per regel

// De regels van de balk onderin. Niet meer dan zes: vanaf 1s is dat 16s, het nummer duurt 16,9s.
export const partyLines = [
  "FEEST!",
  "CELEBRATE GOOD TIMES",
  "WAT EEN TEAM",
  "BIJNA WEEKEND!",
  "DIT BORD STAAT TE DANSEN",
  "TOT DE VOLGENDE VERKOOP",
];

export const partyHypeMs = partyLines.length * partyLineMs;

export const partyLightsMs = 32 * partyBeatMs; // 16,0s

// Snippers vertrekken binnen deze spreiding (s) en vliegen 2,2 tot 3,2s, plus marge.
export const partyCannonSpread = 0.35;
export const partyCannonMs = 3700;

// Salvo's en buien, in slagen na het begin; het eerste salvo na de infade.
const beats = (list) => list.map((beat) => beat * partyBeatMs);
const cannonsAt = beats([4, 10, 16, 22]);
const burstsAt = beats([7, 19]);

// Het feestje vanaf `at` ms, zonder party-blocks (die botsen met de lichtshow).
// ms: eigen duur voor dansen en lichtshow; quiet: dansen zonder eigen nummer.
function partyEvents({
  at = 0,
  hypeAt = partyHypeAt,
  lines = null,
  cannons = cannonsAt,
  bursts = burstsAt,
  ms = null,
  quiet = false,
} = {}) {
  const dance = { ...(ms ? { ms } : {}), ...(quiet ? { quiet } : {}) };
  const lights = ms ? { ms: ms - (partyMs - partyLightsMs) } : {};
  return [
    ["party-dance", dance, at],
    ["party-lights", lights, at],
    ["party-hype", lines ? { lines } : {}, at + hypeAt],
    ...cannons.map((time) => ["party-cannons", {}, at + time]),
    ...bursts.map((time) => ["confetti-burst", { count: 0.9 }, at + time]),
  ];
}

// Het feestje als lijst van [animatie, gegevens, tijd], net als saleGroup in useSaleEvents.js.
export function partyGroup() {
  return partyEvents();
}

// Het targetfeest: de meter loopt naar 100 (target-charge), een slag voor de
// kaart "GEHAALD" start feest-target.mp3 en met de kaart gaat het feest los,
// stil (quiet) want het nummer loopt al. Het eerste salvo valt op de klap van
// het nummer; de balk komt als de kaart weg is.
export const targetCardAt = targetHandoffMs;
export const targetPartyAt = targetCardAt;
const targetCardMs = 9500; // de `ms` van target-hit in registry.js

export const targetSongMs = 31300; // de lengte van feest-target.mp3
const targetSongHitMs = 3000; // de klap in het nummer
export const targetSongAt = targetCardAt - partyBeatMs; // 0,2s na de 100
// Van de kaart tot het nummer uit is.
export const targetPartyMs = targetSongAt + targetSongMs - targetPartyAt; // 30,8s
// De klap, in slagen na de kaart.
const targetHitBeat = (targetSongAt + targetSongHitMs - targetPartyAt) / partyBeatMs; // 5

// Zeven regels van 2,5s, van 10s tot 27,5s.
export const targetLines = [
  "HET UITJE GAAT DOOR",
  "CELEBRATE GOOD TIMES",
  "WAT EEN TEAM",
  "100% GEHAALD",
  "BIJNA WEEKEND!",
  "IEDEREEN BEDANKT",
  "OP NAAR DE VOLGENDE MAAND",
];

// De getallen van `from` tot en met `to`, om de `step`.
const every = (from, to, step) =>
  Array.from({ length: Math.floor((to - from) / step) + 1 }, (_, i) => from + i * step);

export function targetPartyGroup(amount) {
  return [
    ["target-charge", {}, 0],
    ["target-song", {}, targetSongAt],
    // Voor de kaart in de lijst, dan ligt hij er in de animatielaag onder.
    ["target-party-dim", {}, targetPartyAt],
    ["target-hit", { amount, quiet: true }, targetCardAt],
    ...partyEvents({
      at: targetPartyAt,
      hypeAt: targetCardMs + partyBeatMs,
      lines: targetLines,
      // Om de zes slagen een salvo, drie slagen later een bui.
      cannons: beats(every(targetHitBeat, 53, 6)),
      bursts: beats(every(targetHitBeat + 3, 44, 6)),
      ms: targetPartyMs,
      quiet: true,
    }),
  ];
}
